<code class="code-display__value" [attr.empty]="!code()">
	@if (code(); as code) {
		@if (prettify()) {
			@for (char of code | prettifyChars; track $index) {
				<span
					[class]="
						'code-display__char code-display__char--' + char.type
					"
				>
					{{ char.char }}
				</span>
			}
		} @else {
			{{ code }}
		}
	} @else {
		{{ placeholder }}
	}
</code>
